import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/i18n";
import { toast } from "sonner";
import PageHeader from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { Loader2, Download } from "lucide-react";

export default function Help() {
  const { t, lang } = useI18n();
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const r = await api.get(`/help/manual?lang=${lang}`);
        setContent(r.data.markdown || "");
      } catch (e) {
        toast.error(e?.response?.data?.detail || t("error_generic"));
      } finally {
        setLoading(false);
      }
    })();
  }, [t, lang]);

  const downloadPdf = () => {
    window.print();
  };

  if (loading) {
    return (
      <div className="p-10 flex items-center justify-center text-slate-500">
        <Loader2 className="h-5 w-5 animate-spin mr-2" /> {t("loading")}
      </div>
    );
  }

  return (
    <div className="space-y-6 help-printable" data-testid="help-page">
      <div className="help-print-hide">
        <PageHeader
          title={t("help_title")}
          subtitle={t("help_subtitle")}
          testId="help-header"
          action={
            <Button
              onClick={downloadPdf}
              data-testid="download-manual-pdf"
              className="btn-brand"
            >
              <Download className="h-4 w-4 mr-1" /> {t("download_manual_pdf")}
            </Button>
          }
        />
      </div>
      <article className="bg-white border border-slate-200 rounded-xl p-8 md:p-10 max-w-4xl markdown-body help-print-content">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
      </article>
    </div>
  );
}

